<template>
	<BaseCard
		class="relative flex items-center gap-4 py-4 pr-5 pl-27.5"
		alt
		v-hover="{ active: 'scale-95' }"
	>
		<Fair class="absolute bottom-0 -left-0.75" />
		<div>
			<div class="text-label-primary text-sm font-medium capitalize">
				{{ t('howItWorks') }}
			</div>
			<div class="text-label-secondary mt-1 text-sm">
				{{ t('learnAbout') }}
			</div>
		</div>
		<ChevronRightIcon class="text-label-tertiary h-5 w-5 shrink-0 opacity-30" />
	</BaseCard>
</template>
<script setup lang="ts">
import BaseCard from './BaseCard.vue'
import ChevronRightIcon from '@/assets/icons/chevron-right.svg'
import Fair from '@/assets/illustrations/fair.svg'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({
	messages: {
		en: {
			howItWorks: 'How it works',
			learnAbout: 'Learn about our un-riggable games and how we stand out'
		},
		ru: {
			howItWorks: 'Как это работает',
			learnAbout: 'Узнайте о нашей честной игре и чем мы выделяемся'
		}
	}
})
</script>
